"use strict";

(function () {
  'use strict';

  angular.module('auth.interceptor', []).factory('authInterceptor', authInterceptor);
  authInterceptor.$inject = ['$q', '$location', 'AuthService'];

  function authInterceptor($q, $location, AuthService) {
    return {
      // automatically attach Authorization header
      request: function request(config) {
        var token = AuthService.getToken();

        if (token) {
          config.headers.Authorization = 'Bearer ' + token;
        }

        return config;
      },
      response: function response(res) {
        if (res.headers('X-Token')) {
          AuthService.saveToken(res.headers('X-Token'));
        }

        return res;
      },
      // if token is bad, send back to the login page
      responseError: function responseError(response) {
        if (response.status === 401 || response.status === 403) {
          AuthService.logout();
          $location.path('/login');
        }

        return $q.reject(response);
      }
    };
  }
})();